// extracted by css-extract-rspack-plugin
export default {"cls1":"ToolsSidebar-cls1_ljV","cls2":"ToolsSidebar-cls2_LG3 ToolsSidebar-cls1_ljV"};